export default [
    
//  reports  router
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "Statistiques",
      layout: "dashboard",
    },
    path: "/reports",
    name: "reports",
    component: () => import("@/layouts/index/ReportIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Statistiques",
          layout: "dashboard",
        },
        path: "customers",
        name: "reports-customers-index",
        component: () => import("@/views/reports/CustomerReport.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Statistiques",
          layout: "dashboard",
        },
        path: "employees",
        name: "reports-employees-index",
        component: () => import("@/views/reports/EmployeeReport.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Statistiques",
          layout: "dashboard",
        },
        path: "daily/sheet",
        name: "reports-daily-sheet",
        component: () => import("@/views/reports/DailySheet.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Statistiques",
          layout: "dashboard",
        },
        path: "daily/status",
        name: "reports-daily-status",
        component: () => import("@/views/reports/DailyStatus.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Archive Rapport client",
          layout: "dashboard",
        },
        path: "customer/report/archive",
        name: "archives-index",
        component: () => import("@/views/sales/ArchiveCustomerReport.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Archive Rapport client",
          layout: "dashboard",
        },
        path: "customer/report/archive",
        name: "sales-customer-report-archive",
        component: () => import("@/views/sales/ArchiveCustomerReport.vue"),
      },
    ],
  },]